var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpriteChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  y: 133,
  viewBox: "-10 -10 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E48",
  d: "M42 21.5a.5.5 0 0 0-.5-.5h-18a.5.5 0 0 0-.5.5v11.998a.5.5 0 0 0 .5.5h9.167l.267.2 5.066 3.8v-4h3.5a.5.5 0 0 0 .5-.5zm-5.667 16.498-4-3H23.5a1.5 1.5 0 0 1-1.5-1.5v-8.5h-2.5a.5.5 0 0 0-.5.5v11.998a.5.5 0 0 0 .5.5l2.5.002h1v3.998l5.066-3.8.265-.198zM43 21.5v11.998a1.5 1.5 0 0 1-1.5 1.5H39v3C39 38.59 38.514 39 37.996 39a1 1 0 0 1-.26-.042c-.358.059-8.706.038-9.069.038l-5.067 3.8a.98.98 0 0 1-.596.202c-.518 0-1.004-.41-1.004-1.002v-3h-2.5a1.5 1.5 0 0 1-1.5-1.5V25.498a1.5 1.5 0 0 1 1.5-1.5H22V21.5a1.5 1.5 0 0 1 1.5-1.5h18a1.5 1.5 0 0 1 1.5 1.5m-5.5 7.498h-10a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1m.5-3.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1 0-1h10a.5.5 0 0 1 .5.5"
}))));
export default SvgSpriteChat;